const getChecked = (e: any) => e.target.checked;

export default getChecked;
